import { useQuery } from '@tanstack/react-query';
import {
  getOrgNodeAccessConfig,
  OrgNodeAccessConfig,
} from '@/services/admin/get-org-node-access-config';

export const useGetOrgNodeAccessConfig = (orgId: string) => {
  return useQuery<OrgNodeAccessConfig>({
    queryKey: ['org-node-access-config', orgId],
    queryFn: () => getOrgNodeAccessConfig(orgId),
    enabled: !!orgId,
  });
};
